
export default function Hero() {
  return (
    <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c343503d694123c859268c64ad62dd04.jpg"
          alt="TMI Gallery"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full">
        <div className="inline-block bg-[#8B1538]/80 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-semibold mb-6 tracking-wider uppercase font-['Lato']">
          Our Operations in Pictures
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 font-['Montserrat']">
          PHOTO <span className="text-[#D4A574]">GALLERY</span>
        </h1>
        <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto font-['Lato'] leading-relaxed">
          A visual journey through TMI&apos;s mining operations, logistics fleet, and chrome processing facilities
        </p>
      </div>
    </section>
  );
}
